import { render, staticRenderFns } from "./AgregarDetalleLiquidacion.vue?vue&type=template&id=45aff286"
import script from "./AgregarDetalleLiquidacion.vue?vue&type=script&lang=js"
export * from "./AgregarDetalleLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports